import angular from 'angular';

import DataBroker from 'cars-ng-data-broker';
import localStorage from 'cars-ng-browser';

import service from './listing.service';

export default angular.module('cars.vdp.shared.listing', [
    /* your module dependencies go here */
    DataBroker,
    localStorage
])

.factory('listingService', service)

.name;
